import { OrderFeature } from '@aloft/toolkit-shared';
import { Flex, Tabs } from '@aloft/toolkit-sui';

import { useEffect } from 'react';

// eslint-disable-next-line aloft/prefer-sound-ui-button
import { CraftsmanAddCompButtons } from '../../../components/CraftsmanAddCompButtons.tsx';
import { Feature } from '../../../redux/constants.ts';
import { setOrderFeatures } from '../../../redux/features/orderSlice.ts';
import {
  selectOrder,
  selectOrderFeatures,
} from '../../../redux/features/selectors/orderSelectors.ts';
import { selectAivArvActiveTab } from '../../../redux/features/selectors/uiSelectors.ts';
import { getAivArvTabStorageKey, setAivArvActiveTab } from '../../../redux/features/uiSlice.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';
import { AivArvActiveTab } from '../../../redux/types.ts';
import { AddFeaturesPopover } from '../../analysis/modals/objectiveEdit/AddFeaturesPopover.tsx';
// eslint-disable-next-line aloft/prefer-sound-ui-button
import { VerifyAllFeaturesButton } from './VerifyAllFeaturesButton.tsx';
// eslint-disable-next-line aloft/prefer-sound-ui-button
import { ViewZillowListingButton } from './ViewZillowListingButton.tsx';

export const FeatureGridToolbar = () => {
  const dispatch = useAppDispatch();
  const orderFeatures = useAppSelector(selectOrderFeatures);
  const { hasArvOption, id: orderId } = useAppSelector(selectOrder);
  const activeTab = useAppSelector(selectAivArvActiveTab);

  useEffect(() => {
    // Only save to localStorage when order ID is available
    if (orderId) {
      try {
        const storageKey = getAivArvTabStorageKey(orderId);
        window.localStorage.setItem(storageKey, activeTab);
      } catch {
        // Ignore localStorage errors (e.g., in private browsing mode)
      }
    }
  }, [activeTab, orderId]);

  const isFeatureGrid = window.location.pathname.includes('features');

  const tabs: { label: string; value: AivArvActiveTab }[] = [
    { label: 'All', value: 'all' },
    { label: 'As-Is Value', value: 'aiv' },
    { label: 'After-Repair Value', value: 'arv' },
  ];

  return (
    <Flex
      className="toolbar-container"
      flexDirection="column"
      flexShrink={1}
      paddingTop="0.5rem"
      backgroundColor="surface1"
      gap="0px"
    >
      <Flex
        justifyContent="space-between"
        flexWrap="wrap"
        paddingX="24px"
        paddingY="8px"
        alignItems="flex-end"
        gap="0.75rem"
      >
        <Flex gap="1.5rem" alignItems="flex-end">
          <CraftsmanAddCompButtons />
          {isFeatureGrid && (
            <AddFeaturesPopover
              buttonProps={{ variant: 'secondary', size: 'sm' }}
              label="Add Feature"
              features={orderFeatures}
              handleAddFeature={(feature: Feature) => {
                dispatch(setOrderFeatures([...orderFeatures, feature as OrderFeature]));
              }}
            />
          )}
          <ViewZillowListingButton />
        </Flex>
        <Flex alignItems="flex-end">
          <VerifyAllFeaturesButton />
        </Flex>
      </Flex>
      {hasArvOption && (
        <Flex paddingTop="0.5rem" width="100%">
          <Tabs
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={(tab: AivArvActiveTab) => dispatch(setAivArvActiveTab(tab))}
            variant="primary"
          />
        </Flex>
      )}
    </Flex>
  );
};
